import { render, staticRenderFns } from "./GroupMemberDialog.vue?vue&type=template&id=331cee79&scoped=true"
import script from "./GroupMemberDialog.vue?vue&type=script&lang=js"
export * from "./GroupMemberDialog.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberDialog.vue?vue&type=style&index=0&id=331cee79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331cee79",
  null
  
)

export default component.exports